import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './styles/css/init.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-confirm-alert/src/react-confirm-alert.css'
import 'react-toastify/dist/ReactToastify.css'
import 'flatpickr/dist/flatpickr.css'

import './styles/css/index.css'
import './styles/css/login.css'
import './styles/css/navbar.css'
import './styles/css/languageSelect.css'
import './styles/css/dashboard.css'
import './styles/css/footer.css'

// shared
import './styles/css/shared/icons.css'
import './styles/css/shared/alert.css'
import './styles/css/shared/border.css'
import './styles/css/shared/buttons.css'
import './styles/css/shared/certificate.css'
import './styles/css/shared/colors.css'
import './styles/css/shared/dropdown.css'
import './styles/css/shared/infoPosta.css'
import './styles/css/shared/modal.css'
import './styles/css/shared/panel.css'
import './styles/css/shared/popper.css'
import './styles/css/shared/popup.css'
import './styles/css/shared/spinner.css'
import './styles/css/shared/tab.css'
import './styles/css/shared/tag.css'
import './styles/css/shared/sidForm.css'
import './styles/css/shared/width.css'

// form
import './styles/css/form/form.css'
import './styles/css/form/formOnBottom.css'
import './styles/css/form/autocomplete.css'
import './styles/css/form/checkbox.css'
import './styles/css/form/date.css'
import './styles/css/form/input.css'
import './styles/css/form/select.css'

// table
import './styles/css/table/table.css'
import './styles/css/table/headerTable.css'
import './styles/css/table/rowTable.css'
import './styles/css/table/emptyState.css'

// applications
import './styles/css/applications/corpro.css'

import './styles/css/applications/admin.css'
import './styles/css/applications/arco.css'
import './styles/css/applications/blue.css'
import './styles/css/applications/comurei.css'
import './styles/css/applications/cora.css'
import './styles/css/applications/crs.css'

import './styles/css/shared/helpers.css'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
